import React, { FC, ReactElement } from 'react'

import { ConnectedRegistration } from '../../connectors'

const RegistrationPage: FC = (): ReactElement => (
    <ConnectedRegistration />
)

export default RegistrationPage
